import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { getFormMode } from "../../../lib/helpers";
import {
  getdrpFacilitiesMst,
  insertRoomFacLink,
  retriveRoomFacLink,
} from "../../../Api/RoomMst/Api";
import { toast } from "react-toastify";

const Form_Mode = getFormMode();

const fields = [
  { id: "FacilityName", label: "Facility", minWidth: 170 },
  { id: "Facility_Desc", label: "Description", minWidth: 170 },
  { id: "Remark", label: "Remark", minWidth: 100 },
];

export default function RoomMasterFormTwo({ formMode, form, setForm,roomId  }) {
  const isFormDisabled = formMode === Form_Mode.read;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [facilitySelectAll, setFacilitySelectAll] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [selectedFacilityIds, setSelectedFacilityIds] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const fetchSavedFacilities = async () => {
      if (formMode === Form_Mode.edit && roomId) {
        try {
          const response = await retriveRoomFacLink({
            RoomFacId: roomId,
            Flag: "R" // Assuming "R" is for retrieve
          });

          if (response instanceof Error) {
            toast.error("Error: Could not retrieve saved facilities");
            return;
          }

          const { data: { Status, Data, responseStatusCode } } = response;
          
          if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
            setForm(Data.map(facility => ({
              RoomFacId: facility.RoomFacId,
              FacilityId: facility.FacilityId,
              FacilityName: facility.FacilityName,
              Facility_Desc: facility.Facility_Desc,
              Remark: facility.Remark,
              Status: facility.Status
            })));
          }
        } catch (error) {
          toast.error("Error retrieving saved facilities");
        }
      }
      setIsLoading(false);
    };

    fetchSavedFacilities();
  }, [formMode, roomId]);

  // Fetch available facilities and mark selected ones
  useEffect(() => {
    const fetchFacilities = async () => {
      const response = await getdrpFacilitiesMst();

      if (response instanceof Error) {
        toast.error("Error: Facilities dropdown could not be fetched");
        return;
      }

      const { data: { Status, responseStatusCode, Data } } = response;
      
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        // Mark facilities that are already selected
        const updatedFacilities = Data.map(facility => ({
          ...facility,
          isChecked: form.some(f => f.FacilityId === facility.Id)
        }));
        setFacilities(updatedFacilities);
      } else {
        toast.error("Error: Facilities not Found");
      }
    };

    fetchFacilities();
  }, [form]);


  const facilitiesSelectAll = () => {
    const newSelectAll = !facilitySelectAll;
    setFacilitySelectAll(newSelectAll);
    const updatedItems = facilities.map((item)=>({
      ...item,
      isChecked:newSelectAll,
    }));
    setFacilities(updatedItems);
  };
  const facilityCheckboxChange = (Id) => {
    if (Array.isArray(facilities)) {
      const foundObj = facilities.map((obj) =>
        obj.Id === Id ? { ...obj, isChecked: !obj.isChecked } : obj
      );


      setFacilities(foundObj);
      const allChecked = foundObj.every((item)=>item.isChecked);
      setFacilitySelectAll(allChecked);
    }
  };

  const facilitySelect = () => {
    const selectedFacilities = facilities.filter((item) => item.isChecked);

    const dataToDisplay = selectedFacilities.map((a) => ({
      RoomFacId: 0,
      FacilityId: a.Id,
      FacilityName: a.Name,
      Remark: "Api Test", 
      Status: 1,
      CreatedBy: 1,
    }));

    //REMOVING DUPLICATES
    const isInEntry = (id) => form.find((entry) => entry.FacilityId === id);
    const filteredEntries = dataToDisplay.filter(
      (data) => !!isInEntry(data.FacilityId) === false
    );
    console.log("filteredEntries", filteredEntries)
    setForm((prevRows) => [...prevRows, ...filteredEntries]);

    if (selectedFacilities.length > 0) {
      setSelectedFacilityIds(selectedFacilities.map((a) => a.Id));
    } else {
      setSelectedFacilityIds([]);
    }
    //Reset facilities
    const resetFacilities = facilities.map((facility) => ({
      ...facility,
      isChecked: false,
    }));
    setFacilities(resetFacilities);
    setFacilitySelectAll(false);
    setIsConfirmed(true);
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const deleteFacilityId = async (row) => {
    const response = await retriveRoomFacLink({
      RoomId: row.RoomFacId,
      Flag: "D",
    });

    if (response instanceof Error) {
      return toast.error("Error: cannot delete facility");
    }
    const {
      data: { Status, Message, responseStatusCode },
    } = response;

    if (Status === 0 && responseStatusCode === 1) {
      toast.success(Message);
    } else {
      return toast.error(Message);
    }
  };


  const filteredEntries = React.useMemo(() => {
    return form.filter((row) => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === "string") {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === "number") {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, form]);

  // sets facilities
  useEffect(() => {
    (async () => {
      const response = await getdrpFacilitiesMst();

      if (response instanceof Error) {
        return toast.error("Error: Facilities drpdown could not be fetched");
      } else {
        const {
          data: { Status, responseStatusCode, Data },
        } = response;
        if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
          setFacilities(Data);
        } else {
          return toast.error("Error: Facilities not Found");
        }
      }
    })();
  }, []);

 

  return (
    <>
      <Box
        sx={{
          maxWidth: "100vw",
          overflowX: "hidden",
          marginTop: "5px",
          marginRight: "10px",
          marginLeft: "80px",
        }}
      >
        <Grid item lg={12} md={12} xs={12}>
          <Box display="flex" justifyContent="space-between" gap={0}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} className="form_field">
                <List>
                  <ListItem style={{ maxHeight: "200px", maxWidth: "600px" }}>
                    <div>
                      <h3>Select Facilities</h3>
                      <label>
                        <input
                          disabled={isFormDisabled}
                          type="checkbox"
                          checked={facilitySelectAll}
                          onChange={facilitiesSelectAll}
                        />
                        Select All
                      </label>

                      <div
                        style={{
                          maxHeight: "170px",
                          overflowY: "auto",
                          marginTop: "10px",
                          maxWidth: "250px",
                        }}
                      >
                        {Array.isArray(facilities) && facilities.map((item) => (
                          <div key={item.Id}>
                            <label>
                              <input
                                disabled={isFormDisabled}
                                type="checkbox"
                                checked={item.isChecked}
                                onChange={() => facilityCheckboxChange(item.Id)}
                              />
                              {item.Name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </ListItem>
                </List>
                <Grid sx={{ marginTop: "50px" }}>
                  <Button
                    variant="contained"
                    disabled={isFormDisabled}
                    sx={{
                      backgroundColor: "#635bff ",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#635bff ",
                      },
                    }}
                    onClick={facilitySelect}
                  >
                    Confirm
                  </Button>
                </Grid>
                   {/* Show the message when facilities are selected but not confirmed */}
                   {!isConfirmed && facilities.some((item) => item.isChecked) && (
                  <Box sx={{ marginTop: 0, color: "red" }}>
                    Please confirm your selected facilities.
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} md={9} className="form_field">
                <Paper
                  sx={{
                    maxWidth: "100vw",
                    overflow: "hidden",
                    margin: "0px 10px 0px 5px",
                    padding: "0px 0px 0px 0px",
                    border: "1px solid lightgray",
                  }}
                >
                  <TableContainer sx={{ maxHeight: 450 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow
                          sx={{
                            "& > th": {
                              padding: "2px  10px 2px  10px",
                            },
                          }}
                        >
                          {fields.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              <Typography variant="subtitle1" fontWeight="bold">
                                {column.label}
                              </Typography>
                              <TextField
                                size="small"
                                variant="outlined"
                                placeholder={`Search ${column.label}`}
                                onChange={(e) =>
                                  handleSearchChange(column.id, e.target.value)
                                }
                                sx={{
                                  mt: 1,
                                  margin: "0px",
                                  "& .MuiOutlinedInput-input": {
                                    padding: "2px 6px",
                                  },
                                }}
                              />
                            </TableCell>
                          ))}
                          <TableCell>
                            <Typography variant="subtitle1" fontWeight="bold">
                              Action
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredEntries
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => {
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={row.PropId}
                                style={{ cursor: "pointer" }}
                                sx={{
                                  "& > td": {
                                    padding: "2px  14px 2px  19px",
                                  },
                                }}
                              >
                                {fields.map((column) => {
                                  const value = row[column.id];
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {value}
                                    </TableCell>
                                  );
                                })}
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0,
                                    }}
                                  >
                                    <Button
                                      disabled={isFormDisabled}
                                      onClick={() =>
                                        deleteFacilityId(row)
                                      }
                                      sx={{ padding: 0, margin: 0 }}
                                    >
                                      <DeleteIcon
                                        sx={{ marginRight: "80px" }}
                                      />
                                    </Button>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 100]}
                    component="div"
                    count={filteredEntries.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </>
  );
}
